import { FETCH_BOOST, BOOST_FETCHED } from '../actions/boost/getStatus';

export const defaultState = {
  fetching: false,
  data: null,
  error: false,
};

export default (state = defaultState, action = {}) => {
  if (action.type === BOOST_FETCHED && action.error) {
    return { ...defaultState, error: true };
  }

  switch (action.type) {
    case FETCH_BOOST:
      return {
        ...defaultState,
        fetching: true,
      };
    case BOOST_FETCHED:
      return {
        ...defaultState,
        data: action.payload,
      };
    default:
      return state;
  }
};
